export const MANAGE_EXTENSION_LOADING_STATES = {
    FILTER_LOADING: "FILTER_LOADING",
    FILTER_READY: "FILTER_READY",
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    DELETING_RECORD_LOADING: "DELETING_RECORD_LOADING",
    DELETING_RECORD_READY: "DELETING_RECORD_READY",
    EXPORTING_FILE_LOADING: "EXPORTING_FILE_LOADING",
    EXPORTING_FILE_READY: "EXPORTING_FILE_READY",
}

export const MANAGE_EXTENSION_LOADING_STATES_MESSAGE_MAP = {
    [MANAGE_EXTENSION_LOADING_STATES.FILTER_LOADING]: "Filters Loading...",
    [MANAGE_EXTENSION_LOADING_STATES.GRID_LOADING]: "Grid Data Loading...",
    [MANAGE_EXTENSION_LOADING_STATES.DELETING_RECORD_LOADING]: "",
    [MANAGE_EXTENSION_LOADING_STATES.EXPORTING_FILE_READY]: "",
}